import {
  buildFlatQualificationStructure,
  buildRelationalQualificationStructure,
  transformAvailableQualification,
} from '@data/qualification'
import Constants from '@constants'
import {
  getRootPluaralTranslator,
  getRootTranslator,
} from '@utils/get-module-translator'
import api from '@api'
import {
  transformCustomScope,
  transformCustomScopeForServer,
} from '@data/custom-scope'

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

export const getCustomScopeApiById = (moduleName, id) => {
  return api
    .get(`/${moduleName}/customscope/${id}`)
    .then((data) => transformCustomScope(data))
}

export const getAllCustomScopeApi = (filters, offset, limit, params) => {
  const quals = []

  if (filters && 'ids' in filters) {
    quals.push(
      buildRelationalQualificationStructure(
        'id',
        'in',
        filters.ids,
        'long',
        'db'
      )
    )
  }

  if (filters && 'scope' in filters) {
    quals.push(
      buildRelationalQualificationStructure(
        'refModel',
        'in',
        filters.scope === 'ticket'
          ? [
              Constants.REQUEST,
              Constants.PROBLEM,
              Constants.CHANGE,
              Constants.RELEASE,
            ]
          : filters.scope === 'asset'
          ? [
              Constants.ASSET_HARDWARE,
              Constants.ASSET_SOFTWARE,
              Constants.ASSET_NON_IT,
              Constants.ASSET_CONSUMABLE,
              Constants.CMDB,
            ]
          : [],
        'enum',
        'db'
      )
    )
  }

  quals.push(
    buildRelationalQualificationStructure(
      'enabled',
      'equal',
      true,
      'boolean',
      'db'
    )
  )

  return api
    .post(
      '/customscope/search/byqual',
      {
        qualDetails: buildFlatQualificationStructure(quals),
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...params,
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformCustomScope),
        total: data.totalCount,
      }
    })
}

export const getCustomScopeApi = (moduleName, filters, limit, offset) => {
  const quals = []

  if (filters) {
    if ('name' in filters) {
      quals.push(
        buildRelationalQualificationStructure(
          'name',
          'contains',
          filters.name,
          'string',
          'db'
        )
      )
    }

    if (filters.filterType) {
      quals.push(
        buildRelationalQualificationStructure(
          'enabled',
          'equal',
          filters.filterType === 'enabled',
          'boolean',
          'db'
        )
      )
    }
  }

  return api
    .post(
      `/${moduleName}/customscope/search/byqual`,
      {
        qualDetails: quals.length
          ? buildFlatQualificationStructure(quals)
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformCustomScope),
        total: data.totalCount,
      }
    })
}

export const updateCustomScope = (moduleName, id, data) => {
  return api.patch(
    `${moduleName}/customscope/${id}`,
    transformCustomScopeForServer(data),
    {
      message: __rootT('updated_successfully', {
        resource: __rootTc('custom_scope'),
      }),
    }
  )
}

export const deleteCustomScopeApi = (moduleName, id) => {
  return api.delete(`${moduleName}/customscope/${id}`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('custom_scope'),
    }),
  })
}

export const createCustomScopeApi = (moduleName, data) => {
  return api.post(
    `${moduleName}/customscope`,
    transformCustomScopeForServer(data),
    {
      message: __rootT('created_successfully', {
        resource: __rootTc('custom_scope'),
      }),
    }
  )
}

export const getSupportedDataApi = (moduleName) => {
  return api
    .get(`${moduleName}/customscope/supportQual`)
    .then((data) => (data || []).map(transformAvailableQualification))
}
